import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SearchSectionHero from "components/SectionHero/SearchSectionHero";
import SectionHero from "components/SectionHero/SectionHero";
import SearchCards from "components/TripCard/SearchCards";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router";

export default function PageSearch() {
    const search = useLocation().search;
    const keyword = new URLSearchParams(search).get("keyword");

    return (
        <div className="nc-PageHome relative overflow-hidden">
            <Helmet>
                <title>{`Trips ${keyword}`}</title>
            </Helmet>
            <BgGlassmorphism />
            <div className="container relative md:mb-24 lg:mb-32 ">
                <SearchSectionHero className="mt-40  md:mt-0 pt-2 pb-16 mx-auto" />
                <div className="relative -mt-14 md:mt-2">
                    <BackgroundSection />
                    <SearchCards />
                </div>
            </div>

        </div>);
}